import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';

import { RestfulService } from '@app/service/restful.service';

@Injectable({
  providedIn: 'root'
})
export class SystemService {

  constructor(
    private restful: RestfulService,
  ) { }

  // 시스템설정 저장하기
  setSystemConfig( form: any ): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'system',
        version: '1.0',
        action: 'setSystemConfig'
      }, form.value
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }

  // 시스템설정 가져오기
  getSystemConfig(): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'system',
        version: '1.0',
        action: 'getSystemConfig'
      }, {}
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }

}
